<template>
  <page-status class="policy-detail" :loading="loading">
    <van-cell-group>
      <van-cell>
        <cell-header slot="title" title="保单信息" />
      </van-cell>
      <template v-for="(policy, index) in detail.policies">
        <van-cell :title="getTextByType(policy.type, '保单号')" :key="index">
          {{ policy.policyNo }}
        </van-cell>
        <van-cell
          title-class="title-center"
          :title="getTextByType(policy.type, '保障时间')"
          :key="index"
        >
          <div>自{{ policy.startDate }}起</div>
          <div>至{{ policy.endDate }}止</div>
        </van-cell>
      </template>
    </van-cell-group>

    <van-cell-group v-for="(customer, index) in detail.customers" :key="index">
      <van-cell>
        <cell-header slot="title" :title="customer.roleName" />
      </van-cell>
      <van-cell title="姓名">{{ customer.name }}</van-cell>
      <van-cell title="证件类型">{{ customer.certTypeName }}</van-cell>
      <van-cell title="证件号码">{{ customer.certNo }}</van-cell>
    </van-cell-group>

    <van-cell-group>
      <van-cell>
        <cell-header slot="title" title="机动车信息" />
      </van-cell>
      <van-cell title="行驶证车主">{{ detail.vehicle.ownerName }}</van-cell>
      <van-cell title="车牌号">
        {{ detail.vehicle.plateNo || '新车未上牌' }}
      </van-cell>
      <van-cell title="车架号">{{ detail.vehicle.frameNo }}</van-cell>
      <van-cell title="车辆注册日期">{{
        detail.vehicle.registerDate
      }}</van-cell>
      <van-cell title="品牌型号">{{ detail.vehicle.model }}</van-cell>
      <van-cell title="车型座位数">
        {{ detail.vehicle.motorTypeName }}
      </van-cell>
      <van-cell title="车辆使用性质">
        {{ detail.vehicle.usageTypeName }}
      </van-cell>
    </van-cell-group>

    <page-footer />
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import CellHeader from '@/components/CellHeader';
import PageFooter from '@/components/PageFooter';
import * as services from '@/services';

export default {
  name: 'PolicyDetail',
  components: {
    PageStatus,
    CellHeader,
    PageFooter,
  },

  data() {
    return {
      loading: true,
      detail: {
        policies: [],
        customers: [],
        vehicle: {},
      },
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { policyNo, certType, certNo } = this.$route.query;

      services.getPolicy(policyNo, certType, certNo).then(res => {
        this.detail = res.data;
        this.loading = false;
      });
    },

    getTextByType(type, label) {
      return `${type === 'BUSINESS' ? '商业险' : '交强险'}${label}`;
    },
  },
};
</script>
<style lang="less">
.policy-detail {
  .title-center {
    align-self: center;
  }
  .van-cell-group + .van-cell-group {
    margin-top: 12px;
  }
}
</style>
